import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import propTypes from 'prop-types';
import { interactionIcon } from '@/assets/images';
import IconSizes from '@/constants/ui/IconSizes';
import translate from '@/lib/intl/translate';
import { formatDistance } from '@/utils/dates';

const useStyles = makeStyles((theme) => ({
  icon: {
    height: IconSizes.SM,
    marginRight: theme.spacing(0.5),
    width: IconSizes.SM,
  },
}));

function LastInteraction({ date, showEmpty, variant }) {
  const classes = useStyles();

  if (date || showEmpty) {
    return (
      <Box alignItems="center" display="flex">
        <img
          alt={translate('INTERACTION_ICON_ALT')}
          className={classes.icon}
          data-testid="LastInteraction-donor-icon"
          src={interactionIcon}
        />
        <Typography variant={variant}>
          {date ? formatDistance(date) : 'N/A'}
        </Typography>
      </Box>
    );
  }

  return null;
}

LastInteraction.propTypes = {
  date: propTypes.string,
  showEmpty: propTypes.bool,
  variant: propTypes.string,
};

LastInteraction.defaultProps = {
  date: '',
  showEmpty: false,
  variant: 'caption',
};

export default LastInteraction;
